import { Injectable } from '@angular/core';
import { AbstractControl, Validator } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class MatchPassword implements Validator {
	validate(control: AbstractControl) {
		if (control.pristine || control.get('password')?.pristine || control.get('confirmPassword')?.pristine) {
			return null;
		}

		const { password, confirmPassword } = control.value;

		if (password === confirmPassword) {
			control.get('confirmPassword').setErrors(null);
			control.get('password').setErrors(null);

			return null;
		} else {
			control.get('confirmPassword').setErrors({ invalid: true, mustMatch: true });
			control.get('password').setErrors({ invalid: true });

			return { passwordMismatch: true };
		}
	}
}
